import React from "react"
import { Container, Typography, Grid, Box } from "@mui/material"

import  { FooterItemsStyles, FooterStyles } from "./styles/FooterStyles"

/* Component that represents the footer display on interface. */
function Footer() {

    return (
        <Box sx={FooterStyles}>
            <Container>
                <Grid container spacing={0} sx={FooterItemsStyles}>
                    <Grid item>
                        <Typography variant="h6">
                            Precipart Global Digital Solutions
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="h6">
                            v1.3.0
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    )
}

export default Footer
